var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#71c2ea;}.cls-2{fill:#bfebff;}.cls-3,.cls-4{fill:#ff4a4a;}.cls-3{opacity:0.34;}.cls-4{opacity:0.45;}.cls-5{fill:#e52525;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body_marker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.17,427.65c-46-60.89-78-112.95-99-150.23C26.83,262.7,5.93,224.72,2.39,173.7,1,154.24,3,143.84,5.14,138a25.38,25.38,0,0,1,2.8-5.54,34,34,0,0,1,4.63-5.56c20-19.69,66.45-20.61,121.33-2.64-2.13-7.07-12.36-43.68,8.46-78.45C145,41.39,154.7,25.4,172.69,14.45a73.41,73.41,0,0,1,9.93-5.09A71.73,71.73,0,0,1,197.37,5c27.13-5,48.51,6.93,57.27,11.84,33.27,18.63,45.23,50.8,48.42,60.49,3.49-9,22.41-55.53,68.76-70.95,9.18-3.06,30.21-10,53.3-1.28,1.06.4,2.09.83,3.1,1.28a63.93,63.93,0,0,1,11,6.21C453.66,22.6,461.2,36.38,465,43.25c19,34.69,10.06,70.42,7.24,80.29,76-23.09,104.18-5.79,112.67,1.81,1,.89,1.73,1.66,2.23,2.2a42.82,42.82,0,0,1,8.08,13c21.51,53.2-38.73,166.94-56.41,195.25-1.56,2.5-6.91,11.2-14.82,24.12-4.07,6.65-8.82,14.41-14.08,23-9.61,15.74-19,31.6-27.71,47.83l7.4,99.33,5.15,69.2H122.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.33,310.19c1,17.83-9.5,37.16-24.64,47.43-22.15,15-38.91.26-95.37.59-49.16.29-63,11.65-84.37-1.2-15.43-9.27-29.39-27.9-29-46.82.75-39.43,63.51-73,116.71-73C357.72,237.13,420.13,269.24,422.33,310.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.63,100.37c6.39,28.55-4.7,55.32-24.76,59.79s-41.51-15-47.9-43.59,4.69-55.32,24.76-59.79S250.24,71.83,256.63,100.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.06,93.08c-6.39,28.54,4.69,55.31,24.76,59.78s41.51-15,47.9-43.59S420,54,400,49.49,358.45,64.53,352.06,93.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 503.68,
    cy: 203.92,
    rx: 53.01,
    ry: 37.19,
    transform: "translate(21.82 455.1) rotate(-49.57)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 94.64,
    cy: 210.14,
    rx: 37.19,
    ry: 53.01,
    transform: "translate(-113.67 111.55) rotate(-40.43)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "marker"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 386.82,
    cy: 420.8,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 386.82,
    cy: 420.8,
    r: 94.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 386.82,
    cy: 420.8,
    r: 42.61
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMarker);
export default __webpack_public_path__ + "static/media/body_marker.2186eff4e0df97cde21c4cbc55996b76.svg";
export { ForwardRef as ReactComponent };